<main class="main-wrap">
  <div class="left-sidebar-wrapper">
    <app-feeds-company-details-page></app-feeds-company-details-page>
    <!--add for mobile view-->
    <!-- <div class="mobile-btn-wrapper">
      <button class="btn btn-grey-bg">Cancel</button>
    </div> -->
  </div>
  <div class="middle-wrapper" *ngIf="probo">
    <!-- {{probo | json}} -->
    <app-feeds-probo-card [probo]="probo"></app-feeds-probo-card>
  </div>
  <div class="right-sidebar-wrapper">
    <app-industry-report-suggestion></app-industry-report-suggestion>
  </div>
</main>
